import React from "react";

export function BannerTemplate(props) {
    return (
        <div className="certificate-banner">
            <div className={props.bannerStyle}/>
            <div className="certificate-banner-message">
                {props.children}
            </div>
        </div>
    );
}
